import { IUserObject } from '../../components/InitialReport/ReportTriageLevel/types'
import { IUserProfile } from '../../pages/UsersPage/constants'

export interface IUsersState {
  users: IUserObject[]
  organizationUsers: IUserProfile[]
}

export interface IVictimDTO {
  victim: {
    person_type: string
    full_name: string
    description: string
    image?: File | string
    report?: number
  }
  custom_fields?: { title: string; description: string; [key: string]: any }[]
  id?: number
}

// TODO: remove once you update IVictimDTO
export interface IVictimDTO2 {
  victim: {
    business_unit: string
    city: string
    email: string
    location: string
    original_hire_date: string
    phone: string
    state: string
    termination_date: string
    title: string
    work_country: string
    work_site: string
    person_type: string
    full_name: string
    description: string
    image: File | string
    report?: number
  }
  custom_fields?: { title: string; description: string; [key: string]: any }[]
  id?: number
}

export interface ISubjectDTO {
  subject: {
    person_type: string
    full_name: string
    description: string
    image?: File | string
    report?: number
  }
  custom_fields?: { title: string; description: string; [key: string]: any }[]
  id?: number
}

export interface IReportingPartyDTO {
  reporting_party: {
    report: number
    [key: string]: string | number
  }
  custom_fields?: { title: string; description: string; [key: string]: any }[]
  id?: number
}

export enum usersReportRoles {
  LEAD_INVESTIGATOR = 'LEAD_INVESTIGATOR',
  TEAM_MEMBER = 'TEAM_MEMBER',
  OVERSIGHT = 'OVERSIGHT',
}